import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mr-0.5 font-mono" }

import { ContactHealthScoreStats } from '@/types/metrics/ContactHealthScore';
import { getContactHealthScoreTrend } from '@/utils/contactHealthScore';
import { HeartIcon } from '@heroicons/vue/solid';
import { computed } from 'vue';

interface Props {
    healthScore: ContactHealthScoreStats;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactHealthScoreBadge',
  props: {
    healthScore: {}
  },
  setup(__props: any) {

const props = __props;
const status = computed(() => {
    if (props.healthScore?.score === null) return null;
    return getContactHealthScoreTrend(props.healthScore?.score);
});
const scoreColor = (score: number) => {
    if (score >= 70) return 'bg-success-200 text-success-700';
    if (score >= 30) return 'bg-warning-200 text-warning-800';
    return 'bg-danger-200 text-danger';
};

return (_ctx: any,_cache: any) => {
  return (_ctx.healthScore.score !== null)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["inline-flex items-center gap-2 rounded-full px-2 py-1 text-xs font-semibold", scoreColor(_ctx.healthScore.score)]),
        title: "Health score do relacionamento"
      }, [
        _createVNode(_unref(HeartIcon), { class: "h-3 w-3" }),
        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.healthScore.score), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('contact.timeline.stats.healthScore.' + status.value)), 1)
      ], 2))
    : _createCommentVNode("", true)
}
}

})